import React from "react";
import Heading from "components/Event/Settings/Heading";

const Header = () => <Heading title="Fuzion Integration" />;

export default Header;
